import { render, staticRenderFns } from "./CityDetailDistrict.vue?vue&type=template&id=e5648afa&scoped=true&"
import script from "./CityDetailDistrict.vue?vue&type=script&lang=js&"
export * from "./CityDetailDistrict.vue?vue&type=script&lang=js&"
import style0 from "./CityDetailDistrict.vue?vue&type=style&index=0&id=e5648afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5648afa",
  null
  
)

component.options.__file = "CityDetailDistrict.vue"
export default component.exports